import { Link } from "react-router-dom";
import "../css/Footer.css";

const Footer = () => {
  return (
    <footer className="night-footer">

      <div className="footer-main">

        {/* BIG BRAND */}
        <div className="footer-brand-block">
          <h2>
            NEO<br />
            <span>CAFÉ</span>
          </h2>
          <p>
            Night brewed coffee.<br />
            Quiet conversations.<br />
            A modern city ritual.
          </p>
        </div>

        {/* CONTENT */}
        <div className="footer-content">

          <div className="footer-col">
            <span>Explore</span>
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/menu">Menu</Link>
            <Link to="/gallery">Gallery</Link>
          </div>

          <div className="footer-col">
            <span>Info</span>
            <Link to="/reviews">Reviews</Link>
            <Link to="/faqs">FAQs</Link>
            <Link to="/contact">Contact</Link>
          </div>

          <div className="footer-col">
            <span>Visit</span>
            <p>Open Daily</p>
            <p>8:00 PM – 2:00 AM</p>
            <p>Downtown · NYC</p>
          </div>

        </div>
      </div>

      {/* OFFSET BOTTOM */}
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Neo Café</span>
        <span>Crafted after dark</span>
      </div>

    </footer>
  );
};

export default Footer;
